import { IHttpService, IPromise, IRequestShortcutConfig } from "angular";
import { EnvironmentService } from "@gtmhub/env";
import { ICollection } from "@webapp/core/core.models";
import { IAttachment, IGetAttachmentsParams, INewAttachment } from "../models";

export class AttachmentService {
  public static $inject = ["$http", "EnvironmentService"];

  constructor(private $http: IHttpService, private env: EnvironmentService) {}

  public createAttachment(attachment: INewAttachment): IPromise<IAttachment> {
    const url = this.env.getApiEndpoint("/attachments");

    return this.$http.post<IAttachment>(url, attachment).then((response) => response.data);
  }

  public getAttachments(params: IGetAttachmentsParams): IPromise<ICollection<IAttachment>> {
    const url = this.env.getApiEndpoint("/attachments");
    const requestConfig: IRequestShortcutConfig = {
      params,
    };

    return this.$http.get<ICollection<IAttachment>>(url, requestConfig).then((response) => response.data);
  }

  public getAttachment(attachmentId: string): IPromise<IAttachment> {
    const url = this.env.getApiEndpoint(`/attachments/${attachmentId}`);

    return this.$http.get<IAttachment>(url).then((response) => response.data);
  }

  public deleteAttachment(attachmentId: string): IPromise<unknown> {
    const url = this.env.getApiEndpoint(`/attachments/${attachmentId}`);

    return this.$http.delete(url);
  }
}
